import Lazy from './modules/lazy';

import OperationsMap from './sections/operations-map';
import OperationsPopup from './sections/operations-popup';
import OperationsSlider from './sections/operations-slider';

import 'swiper/swiper-bundle.css'
import '../styles/app.scss'

new Lazy;
new OperationsMap;
new OperationsPopup;
new OperationsSlider;
